const interfacePhrases = {
    rate_limited: 'Ograniczenie częstotliwości',
    limit_exceeded: 'Przekroczenie limitu',
    used: 'Użycie',
    identifier: 'Identyfikator',
    verification: 'Weryfikacja',
    messages: 'Wiadomości',
    data: 'Dane',
    custom: 'Niestandardowe',
    management_api: 'API zarządzania {{product}}',
    management_api_role_description: 'Ta wbudowana rola zapewnia dostęp do API zarządzania.',
    client_credentials: 'Dane uwierzytelniające klienta',
    authentication_request: 'Żądanie uwierzytelnienia',
    callback: 'Powrót uwierzytelnienia',
    help_title: 'Centrum pomocy iden',
    help_subtitle: 'Pomoc bez opuszczania obszaru roboczego',
    open_help: 'Otwórz pełną stronę pomocy',
    close_help: 'Zamknij pomoc',
    about: 'Informacje i otwarte oprogramowanie',
    open_navigation: 'Otwórz nawigację',
    close_navigation: 'Zamknij nawigację',
    development_enabled: 'Funkcje programistyczne włączone',
    beta: 'Beta',
    impersonation: 'Podszywanie się pod użytkownika',
    key: 'Klucz',
    value: 'Wartość',
    error: 'Błąd',
    details: 'Szczegóły techniczne',
    callback_failed: 'Nie udało się zakończyć powrotu z logowania.',
    back_sign_in: 'Powrót do logowania',
    powered_by: 'Obsługiwane przez',
    avatar: 'Awatar',
    logo: 'Logo',
    qr_code: 'Kod QR',
    sample_title: 'Chcesz zobaczyć przykład?',
    sample_description: 'Poznaj przykładową aplikację korzystającą z tego przewodnika.',
    sample_action: 'Zobacz przykład',
    further_readings: 'Dalsza lektura',
    complete_guide: 'Pełny przewodnik',
    custom_domains_notice: 'Po dodaniu <a>własnych domen</a> możesz użyć tego punktu końcowego: <code>{{endpoint}}</code>.',
    my_project: 'Mój projekt',
    my_secret: 'Mój sekret',
    my_token: 'Mój token',
    role_example: 'Czytelnik',
    reset_retry: 'Zresetuj konfigurację i ponów próbę',
    open_dev_panel: 'Otwórz panel programisty',
    close_dev_panel: 'Zamknij panel programisty',
    configuration: 'Konfiguracja',
    app_id: 'Identyfikator aplikacji',
    extra_parameters: 'Dodatkowe parametry logowania',
    prompt: 'Monit uwierzytelniania',
    scope: 'Zakres',
    resource: 'Zasób',
    resources_space_delimited: 'Zasoby (oddzielone spacjami)',
    sign_out_to_apply: 'Wyloguj się, aby zastosować zmiany.',
    refresh_token_grant: 'Autoryzacja tokenem odświeżania',
    organization_id: 'Identyfikator organizacji',
    console_result: 'Wynik znajdziesz w konsoli przeglądarki.',
    request_token: 'Zażądaj tokenu',
    user_info: 'Informacje o użytkowniku',
    get_id_token_claims: 'Pobierz oświadczenia tokenu tożsamości',
    fetch_user_info: 'Pobierz informacje o użytkowniku',
    device_initializing: 'Inicjowanie autoryzacji urządzenia…',
    device_success: 'Pomyślnie zalogowano do aplikacji demonstracyjnej.',
    sign_in_information: 'Twoje informacje logowania:',
    email: 'E-mail',
    username: 'Nazwa użytkownika',
    user_id: 'Identyfikator użytkownika',
    sign_out_demo: 'Wyloguj z demonstracji',
    device_expired: 'Kod urządzenia wygasł',
    generic_error: 'Wystąpił błąd',
    device_expired_description: 'Kod urządzenia wygasł. Spróbuj ponownie, aby uzyskać nowy kod.',
    sign_in_title: 'Zaloguj się na swoje konto',
    scan_instruction: 'Zeskanuj kod QR lub otwórz ten adres na innym urządzeniu:',
    one_time_code: 'Wpisz kod jednorazowy',
    token_info: 'Informacje o tokenie',
    get_access_token: 'Pobierz token dostępu',
    context_unavailable: 'Nie można załadować informacji o koncie.',
    not_initialized: 'Informacje o koncie nie zostały zainicjowane.',
    not_set: 'Nie ustawiono',
    configured: 'Skonfigurowano',
    password: 'Hasło',
    phone: 'Numer telefonu',
    search_help: 'Szukaj w pomocy',
    language: 'Język',
    menu: 'Menu',
    compatibility_notice: 'Zgodność: odziedziczone nazwy SDK, pakietów, protokołów, komponentów i nagłówków żądań Logto pozostają bez zmian.',
    source: 'Źródło',
    upstream_repository: 'Repozytorium źródłowe',
    current_fork: 'Bieżące repozytorium',
    license_notice: 'iden bazuje na Logto, otwartym oprogramowaniu udostępnianym na licencji Mozilla Public License 2.0.',
    about_description: 'Informacje o produkcie i autorstwie otwartego oprogramowania.',
    page_not_found: 'Nie znaleziono strony',
    page_not_found_description: 'Ta strona jest niedostępna. Wróć do centrum pomocy, aby kontynuować.',
    introduction: 'Wprowadzenie',
    quick_starts: 'Szybki start',
    integration: 'Integracja',
    end_user_flows: 'Przepływy użytkownika końcowego',
    authorization: 'Autoryzacja',
    user_management: 'Zarządzanie użytkownikami',
    security: 'Bezpieczeństwo',
    customization: 'Dostosowywanie',
    connectors: 'Konektory',
    organizations: 'Organizacje',
    self_hosting: 'Własny hosting',
    continue: 'Kontynuuj',
    loading: 'Ładowanie…',
    save: 'Zapisz',
    saved: 'Zapisano',
    try_again: 'Spróbuj ponownie',
    client_id: 'Identyfikator klienta',
    client_secret: 'Sekret klienta',
    redirect_uri: 'URI przekierowania',
    status: 'Stan',
    type: 'Typ',
    permissions: 'Uprawnienia',
    token_data: 'Dane tokenu',
    context_data: 'Dane kontekstu',
    jwt_extra_claims: 'Dodatkowe oświadczenia tokenu',
    action_result: 'Wynik działania',
    social_account_already_linked: 'To konto społecznościowe jest już połączone.',
};
export default Object.freeze(interfacePhrases);
